import React, { useEffect } from 'react';
import { useAPIWrapper } from 'drf-react-by-schema';
import { useNavigate } from 'react-router-dom';

import { appDispatch } from 'src/utils/utils';
import { setPage } from 'src/features/pageSlice';

export default function Signout() {
  const { signOut } = useAPIWrapper();
  const navigate = useNavigate();
  useEffect(() => {
    signOut();
    appDispatch(
      setPage({
        usuaria: null,
        perfil: null,
      })
    );
    navigate('/login');
  }, []);

  return <></>;
}
